module.exports = __webpack_public_path__ + "static/media/database.28b8464f.svg";